module.exports = "<div id=\"content\">\n\t<app-source-tree-folder *ngIf='sourceTree.id != 0' [sourceTree]=\"sourceTree\"></app-source-tree-folder>\n</div>\n"